import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { IncomeActions } from './income.actions';
import { IIncomeState } from './income.state';

export const initialIncomeState: IIncomeState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const incomeReducerFn = createReducer(
  initialIncomeState,
  on(IncomeActions.reset, (state: IIncomeState, action) => {
    return new StateBuilder<IIncomeState>(initialIncomeState).build();
  }),
  on(IncomeActions.load, (state: IIncomeState, action) => {
    return new StateBuilder<IIncomeState>(state).toLoading().build();
  }),
  on(IncomeActions.loadSuccess, (state: IIncomeState, action) => {
    return new StateBuilder<IIncomeState>(state, action).toLoaded().build();
  }),
  on(IncomeActions.submit, (state: IIncomeState, action) => {
    return new StateBuilder<IIncomeState>(state).toLoading().build();
  }),
  on(IncomeActions.submitSuccess, (state: IIncomeState, action) => {
    return new StateBuilder<IIncomeState>(state, action).toLoaded().build();
  })
);

export function incomeReducer(state: IIncomeState | undefined, action: Action) {
  return incomeReducerFn(state, action);
}
